import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCCContext } from '../CC/CCContext';
import * as ccUtils from '../CC/utils';
import styles from './ObjAssocMobile.module.css';
import ObjAssocIcon from './ObjAssocIconMobile';

interface RecordProps {
    record: any;
    setAndKeepMainY: (newMainY: number, prevMainY: number) => void;

}

const ObjAssoc: React.FC<RecordProps> = ({ record, setAndKeepMainY }) => {
    const { t } = useTranslation();
    const [records, setRecords] = useState<any[]>([]);
    const ctx = useCCContext();
    const [isObjAssocVisible, setIsObjAssocVisible] = useState(false);


    const toggleObjAssoc = () => {
        setIsObjAssocVisible(!isObjAssocVisible);
    };

    useEffect(() => {
        const normalizeToArray = (value: any) => {
            if (!value) return []; // Handle undefined or null values
            return Array.isArray(value) ? value : [value]; // Normalize to array
        };

        const fetchTitles = async () => {
            //const objAssoc = normalizeToArray(record?.data?.Record?.Associations);
            //const icoAssoc = normalizeToArray(record?.data?.Record?.IAssociations);
            //// Determine which association to use based on availability and content
            //const assoc = objAssoc.length > 0 ? objAssoc : icoAssoc;
            //const searchNumbers = assoc.map((item: any) => `${item.ObjectNumber || item.ObjectNumber2}`).join('|');

            //const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=SearchNumber,ObjectNumber2,ObjectNumber=${searchNumbers}&fields=*&range=1-20&responseFormat=json`;
            let query = `/Record/Associations/ObjectNumber,/Record/IAssociations/ObjectNumber=${record.data.Record.ObjectNumber ? record.data.Record.ObjectNumber : record.data.Record.ObjectNumber2}`;

            if (record.data.Record.Associations) {
                // Ensure Associations is treated as an array
                const assocArr = Array.isArray(record.data.Record.Associations)
                    ? record.data.Record.Associations
                    : [record.data.Record.Associations];

                // Map over the array and construct the desired format
                const assocQueries = assocArr.map((assoc: any) =>
                    `/Record/ObjectNumber,/Record/ObjectNumber2=${assoc.ObjectNumber}`
                ).join(';');

                // Construct the final query with 'or' logic
                query = `or(${query};${assocQueries})`;
            }

            if (record.data.Record.IAssociations) {
                // Ensure Associations is treated as an array
                const assocArr = Array.isArray(record.data.Record.IAssociations)
                    ? record.data.Record.IAssociations
                    : [record.data.Record.IAssociations];

                // Map over the array and construct the desired format
                const assocQueries = assocArr.map((assoc: any) =>
                    `/Record/ObjectNumber,/Record/ObjectNumber2=${assoc.ObjectNumber}`
                ).join(';');

                // Construct the final query with 'or' logic
                query = `or(${query};${assocQueries})`;
            }

            console.log('QUERY: ', query);

            //console.log(record.data.Record.Associations);
            //console.log(record.data.Record.IAssociations);
            //const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=/Record/Associations/ObjectNumber,/Record/IAssociations/ObjectNumber=%22${record?.data?.Record.ObjectNumber ? record?.data?.Record.ObjectNumber : record?.data?.Record.ObjectNumber2 }%22&fields=*&range=1-200&responseFormat=json`;
            const url = `${process.env.REACT_APP_BASE_URL}/?action=get&command=search&query=${query}&fields=*&range=1-200&responseFormat=json`;

            console.log("URL: ", url);
            try {
                const response = await fetch(url);
                const data = await response.json();
                let fetchedRecords: any[] = [];

                if (Array.isArray(data.records.record)) {
                    fetchedRecords = data.records.record;
                } else if (data.records.record) {
                    fetchedRecords = [data.records.record];
                }

                const validRecords = fetchedRecords.filter((item: any) => item?.data?.Record?.ObjectNumber != null || item?.data?.Record?.ObjectNumber2 != null);
                setRecords(validRecords);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchTitles();
    }, [record]);

    
  const showSearch = () => {
    setAndKeepMainY(-200, -300);
  }

    const handleLinkClick = (event: React.MouseEvent, index: number) => {
        event.preventDefault();
        const objectNumber = records[index].data?.Record?.ObjectNumber || records[index].data?.Record?.ObjectNumber2;
        console.log(objectNumber);
        console.log(records[index].data?.Record?.searchnumber);
        ccUtils.customSearch(ctx, '/Record/ObjectNumber,/Record/ObjectNumber2', '', '[' + objectNumber + ']', 'Numéro d\'inventaire' + ' : ' + objectNumber);
        showSearch();
    };

    return (
        <div>
            {records.length > 0 &&
                <div className={styles.foldableSection}>
                    <div className={styles.foldableLabel} onClick={toggleObjAssoc}>
                        <span className={styles.taglabel}>{t('Notices reliées')} : </span> <button onClick={toggleObjAssoc} className={styles.toggleButtonAssoc}>{isObjAssocVisible ? '-' : '+'}</button>
                    </div>
                    {isObjAssocVisible && (
                        <div className={styles.objAssoc}>
                            <div className={styles.ObjAssoc}>
                                {records.map((record: any, index: number) => (
                                    <ObjAssocIcon
                                        key={index}
                                        record={record}
                                        index={index}
                                        handleLinkClick={handleLinkClick}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default ObjAssoc;
